import { Loader } from "@googlemaps/js-api-loader";

export default {
	GOOGLE_API_KEY: `AIzaSyCaWB0ygDeFhm3adRwRjo7g6ej7IBRyo7Y`,
	GOOGLE_MAPS_LOADER: null,
	async getGoogleMapsClient() {
		if (this.GOOGLE_MAPS_LOADER) return this.GOOGLE_MAPS_LOADER;

		const loader = new Loader({
			apiKey: this.GOOGLE_API_KEY,
			version: "weekly",
			libraries: ["geocoding", "maps", "places"]
		});

		this.GOOGLE_MAPS_LOADER = await loader.load();

		return this.GOOGLE_MAPS_LOADER;
	}
}